import PlainDate from '@Domain/PlainDate';
import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Calendar } from '@verclam/ui-kit';

const dateFieldPt = { root: { style: { width: '11rem' } } };

type Props = { edge: 'from' | 'to' };

/**
 * One bound of the period. Each bound is limited by the other, so the signal never holds an
 * inverted period; a cleared field is ignored and the chosen date comes back.
 */
const PeriodDateField: React.FC<Props> = ({ edge }) => {
	const filters = useSignalValue(aiCostsFiltersSignal);
	const isFrom = edge === 'from';

	const handleChange = React.useCallback(
		(value: Date | null) => {
			if (value === null || value === undefined) {
				return;
			}

			const date = PlainDate.fromCalendar(value);
			const current = aiCostsFiltersSignal.peek();

			setAiCostsFilters(
				isFrom ? current.setPeriod(date, current.to) : current.setPeriod(current.from, date),
			);
		},
		[isFrom],
	);

	return (
		<Calendar
			name={isFrom ? 'aiCostsPeriodFrom' : 'aiCostsPeriodTo'}
			label={isFrom ? 'Du' : 'Au'}
			dateFormat="dd/mm/yy"
			value={(isFrom ? filters.from : filters.to).toCalendar()}
			onChange={handleChange}
			maxDate={isFrom ? filters.to.toCalendar() : undefined}
			minDate={isFrom ? undefined : filters.from.toCalendar()}
			showIcon
			pt={dateFieldPt}
		/>
	);
};

export default PeriodDateField;
